module.exports = __webpack_public_path__ + "img/bob.i.880b9c06.png";